export default class MessageBox {
    messageBoxes: NodeListOf<Element>;

    constructor() {
        this.messageBoxes = document.querySelectorAll('.message-box');
    }

    init() {
        if (this.messageBoxes.length > 0) {
            Array.prototype.forEach.call(this.messageBoxes, messageBox => {
                const textarea = messageBox.querySelector('textarea');
                const maxChars = Number(textarea.getAttribute('maxlength'));
                const charCountMessage = messageBox.querySelector('.counter-message');

                charCountMessage.textContent = maxChars;

                textarea.addEventListener('input', () => {
                    const currentLength = textarea.value.length;
                    charCountMessage.textContent = String(maxChars - currentLength);
                });
            });
        }
    }
}